import React, { useState } from "react";

const DropdownWithCustomInput = () => {
  const [numericValue, setNumericValue] = useState(5.0); // Default dropdown value
  const [showDropdown, setShowDropdown] = useState(false); // Toggle dropdown visibility
  const [showCustomInput, setShowCustomInput] = useState(false); // Toggle custom input
  const [customAmount, setCustomAmount] = useState(""); // Custom amount entered

  // Format amount (example: USD 5.00)
  const formatAmount = (value) => parseFloat(value).toFixed(2);

  // Handle dropdown item selection
  const handleSelect = (value) => {
    if (value === "Enter own amount") {
      setShowCustomInput(true);
      setShowDropdown(false); // Hide dropdown after selecting "Enter own amount"
    } else {
      setNumericValue(value.replace("USD ", ""));
      setShowCustomInput(false);
      setShowDropdown(false); // Close dropdown after selection
    }
  };

  // Handle custom input changes
  const handleCustomAmountChange = (e) => {
    setCustomAmount(e.target.value);
  };

  // Submit custom amount
  const handleCustomAmountSubmit = () => {
    if (!isNaN(customAmount) && customAmount > 0) {
      setNumericValue(customAmount);
      setShowCustomInput(false);
      setShowDropdown(false); // Close dropdown after submission
      setCustomAmount("");
    } else {
      alert("Please enter a valid amount.");
    }
  };

  // Cancel custom input
  const handleCancel = () => {
    setShowCustomInput(false);
    setCustomAmount("");
    setShowDropdown(false); // Close dropdown
  };

  return (
    <div style={{position: 'relative'}} className="dropdown">
      {/* Dropdown Button */}
      <button
        className="btn btn-info text-uppercase dropdown-toggle"
        type="button"
        id="dropdownMenuButton"
        onClick={() => setShowDropdown(!showDropdown)} // Toggle dropdown visibility
        aria-expanded={showDropdown}
      >
        USD {formatAmount(numericValue || 0)}
      </button>
      <p className="text-sm text-uppercase pay-as">
            {showCustomInput
              ? ""
              : `For $${formatAmount(numericValue)}, you get ${formatAmount(numericValue * 50)} credits.`}
          </p>

      {/* Dropdown Menu */}
      {showDropdown && !showCustomInput && (
        <ul
          className="p-2"
          style={{
            background: '#00284F',
            position: "absolute",
            // bottom: "100%", 
            top: '40px',
            zIndex: 1, 
            
          }}
        >
          <li style={{listStyle: 'none'}}>
            <button
              className="dropdown-item"
              onClick={() => handleSelect("USD 5.00")}
            >
              USD 5.00
            </button>
          </li>
          <li style={{listStyle: 'none'}}>
            <button
              className="dropdown-item"
              onClick={() => handleSelect("USD 10.00")}
            >
              USD 10.00
            </button>
          </li>
          <li style={{listStyle: 'none'}}>
            <button
              className="dropdown-item"
              onClick={() => handleSelect("USD 15.00")}
            >
              USD 15.00
            </button>
          </li>
          <li style={{listStyle: 'none'}}>
            <button
              className="dropdown-item"
              onClick={() => handleSelect("USD 20.00")}
            >
              USD 20.00
            </button>
          </li>
          <li style={{listStyle: 'none'}}>
            <button
              className="dropdown-item"
              onClick={() => handleSelect("Enter own amount")}
            >
              Enter own amount
            </button>
          </li>
        </ul>
      )}

      {/* Custom Amount Input */}
      {showCustomInput && (
        <div className="mb-2 enter-ammount">
          <input
            type="text"
            className="enter-ammount-input"
            placeholder="Enter amount"
            value={customAmount}
            onChange={handleCustomAmountChange}
          />
          <button onClick={handleCustomAmountSubmit} className="btn btn-info">
            OK
          </button>
          <button onClick={handleCancel} className="btn btn-danger">
            X
          </button>
        </div>
      )}
    </div>
  );
};

export default DropdownWithCustomInput;
